"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = void 0;
class ValidationError extends Error {
    constructor(zodError) {
        super('Validation failed');
        this.statusCode = 400;
        this.name = 'ValidationError';
        this.issues = zodError.issues;
    }
    toResponse() {
        return {
            error: 'Validation failed',
            issues: this.issues.map((i) => ({
                path: i.path.join('.'),
                message: i.message,
            })),
        };
    }
    static isValidationError(error) {
        return error instanceof ValidationError;
    }
}
exports.ValidationError = ValidationError;
//# sourceMappingURL=errors.js.map